/* @jsx mdx */
  import React from 'react'
  import { mdx } from '@mdx-js/react'
  /* @jsx mdx */
import Form from '../FormTest';
import FormTextField from '../../src/components/FormTextField';
import { Playground, Props } from 'docz';

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "formtextfield"
    }}>{`FormTextField`}</h1>
    <h2 {...{
      "id": "example"
    }}>{`Example`}</h2>
    <Playground __position={0} __code={'<Form\n  render={() => {\n    return (\n      <FormTextField icon=\"extension\" name=\"fieldName\" label=\"Field Label\" />\n    )\n  }}\n/>'} __scope={{
      props: this ? this.props : props,
      Form,
      FormTextField,
      Playground,
      Props
    }} mdxType="Playground">
  <Form render={() => {
        return <FormTextField icon="extension" name="fieldName" label="Field Label" mdxType="FormTextField" />;
      }} mdxType="Form" />
    </Playground>
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <Props of={FormTextField} mdxType="Props" />
    </MDXLayout>;
}

MDXContent.isMDXComponent = true;
  